/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const customerWalletTransactionDataSchema = z.object({
	id: z.number(),
	type: z.string(),
	amount: z.number(),
	runningBalance: z.number(),
	createdAt: z.iso.datetime(),
})

export type CustomerWalletTransactionDataSchema = z.infer<typeof customerWalletTransactionDataSchema>
